import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { ReportsDashboardComponent } from './reports-dashboard/reports-dashboard.component';
import { ViewReportsComponent } from './view-reports/view-reports.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';


@NgModule({
  declarations: [ReportsDashboardComponent,ViewReportsComponent],
  imports: [PowerBIEmbedModule,
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ReportBeforeLoginComponent: {
          component: ReportsDashboardComponent,
        },
      },
    } as CmsConfig)
  ],
  providers: [
    provideOutlet({
      id: 'ReportBeforeLoginSlot',
      position: OutletPosition.REPLACE,
      component: ReportsDashboardComponent,
    }),
  ],
  exports: [ReportsDashboardComponent]
})
export class ReportsModule { }
